import type { HelpArticle } from '../../../components/help/types';

export const keyboardShortcutsArticles: HelpArticle[] = [
  {
    id: 'shortcuts-reference',
    title: 'Keyboard Shortcuts Reference',
    summary: 'Complete list of keyboard shortcuts.',
    category: 'shortcuts',
    order: 1,
    keywords: ['keyboard', 'shortcuts', 'hotkeys', 'keys', 'quick', 'fast'],
    content: `
# Keyboard Shortcuts Reference

Use these shortcuts to work faster.

## Navigation

| Shortcut | Action |
|----------|--------|
| \`Ctrl + K\` | Open quick search |
| \`Shift + ?\` | Show shortcuts help |
| \`Esc\` | Close modal/dialog |
| \`G then D\` | Go to Dashboard |
| \`G then R\` | Go to Records |
| \`G then P\` | Go to PFiles |
| \`G then T\` | Go to Tasks |
| \`G then S\` | Go to Search |

## Document Actions

| Shortcut | Action |
|----------|--------|
| \`Ctrl + N\` | New document |
| \`Ctrl + U\` | Upload file |
| \`Ctrl + S\` | Save changes |
| \`Ctrl + D\` | Download |
| \`Del\` | Delete selected |

## Selection

| Shortcut | Action |
|----------|--------|
| \`Ctrl + A\` | Select all |
| \`Shift + Click\` | Select range |
| \`Ctrl + Click\` | Toggle selection |

## Workflow Actions

| Shortcut | Action |
|----------|--------|
| \`A\` | Approve (when viewing) |
| \`R\` | Reject (when viewing) |
| \`C\` | Add comment |

## Tips

- On Mac, use \`Cmd\` instead of \`Ctrl\`
- Some shortcuts require focus on specific areas
- Press \`Shift + ?\` anytime to see available shortcuts
    `,
  },
];
